export default __webpack_public_path__ + "static/media/Pay.ea5d2669.mp3";